import { useEnvironment } from '@wix/yoshi-flow-editor';
import React from 'react';
import { Divider, Text } from 'wix-ui-tpa/cssVars';
import { DaySectionViewModel } from '../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { LayoutTypes } from '../../../../types/types';
import { AgendaItem } from './AgendaItem/AgendaItem';
import { classes, st } from './DaySection.st.css';
// import settingsParams from '../../../../components/DailyAgenda/settingsParams'; TODO: add sticky behavior back when ready
import Sticky from 'react-sticky-el';
import { useDatePicker } from '../../../../components/DailyAgenda/hooks/useDatePicker';

export const DaySection: React.FC<DaySectionViewModel> = ({
  _dateISO,
  date,
  splittedDate,
  agendaItems,
  layoutType = LayoutTypes.LIST,
}) => {
  const { isMobile } = useEnvironment();
  // const settings = useSettings(); TODO: add sticky behavior back when ready
  const sectionId = splittedDate.date.replaceAll(' ', '-');
  const { setCurrentDate } = useDatePicker();

  // const isDateSticky = settings.get(settingsParams.dateSticky); TODO: add sticky behavior back when ready

  const renderDate = () => {
    if (isMobile) {
      return <Text className={classes.date}>{date}</Text>;
    }

    return (
      <>
        <Text className={classes.splittedDate}>{splittedDate.date}</Text>
        <Text className={classes.splittedDay}>{splittedDate.day}</Text>
      </>
    );
  };

  return (
    <section
      className={st(classes.root, { layoutType, isMobile })}
      // className={st(classes.root, { layoutType, isMobile, isDateSticky })} TODO: add sticky behavior back when ready
      id={sectionId}
    >
      <Sticky
        // disabled={!isDateSticky} TODO: add sticky behavior back when ready
        scrollElement="#stickyContainer"
        boundaryElement={`#${sectionId}`}
        onFixedToggle={(state) => {
          if (state) {
            setCurrentDate(new Date(_dateISO));
          }
        }}
      />
      <div
        className={st(classes.dateContainer, classes.listItem)}
        role="presentation"
      >
        {renderDate()}
      </div>
      <ul className={classes.slotList}>
        {agendaItems.map((agendaItemViewModel, index) => (
          <li
            className={classes.slotContainer}
            key={agendaItemViewModel.slotId}
          >
            <AgendaItem
              layoutType={layoutType}
              agendaItemViewModel={agendaItemViewModel}
            />
            <Divider className={classes.agendaItemDivider} />
          </li>
        ))}
      </ul>
    </section>
  );
};
